import script from "./Costs.vue?vue&type=script&setup=true&lang=js"
export * from "./Costs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__